import { sendRequest, types as commonTypes } from './backendCommon';
import { REQUESTS } from '../../constants/backend';

type Dispatch = (action: unknown) => unknown;

export type EventMeta = Record<string, unknown>;
type EventStatus = 'loading' | 'success' | 'error';

interface UserEventBody {
    eventType: string;
    timestamp: string;
    callId?: string;
    meta?: EventMeta;
}

interface SalesEventBody extends EventMeta {
    eventType: string;
    timestamp: string;
    callId?: string;
}

export const logUserEvent =
    (eventType: string, callId: string | null = null, meta: EventMeta | null = null) =>
    (dispatch: Dispatch) => {
        if (!eventType) {
            return;
        }

        const body: UserEventBody = {
            eventType,
            timestamp: new Date().toISOString()
        };

        if (callId) {
            body.callId = callId;
        }

        if (meta) {
            body.meta = meta;
        }

        dispatch(
            sendRequest(REQUESTS.LOG_USER_EVENT, {
                payload: {
                    body
                }
            })
        );
    };

export const logSalesEvent =
    (eventType: string, callId: string | null = null, meta: EventMeta | null = null) =>
    (dispatch: Dispatch) => {
        if (!eventType) {
            return;
        }

        const body: SalesEventBody = {
            eventType,
            timestamp: new Date().toISOString(),
            ...(meta || {})
        };

        if (callId) {
            body.callId = callId;
        }

        const updateStatus = (status: EventStatus) => {
            dispatch({
                type: commonTypes.SALES_TRACKING_STATUS,
                payload: {
                    status
                }
            });
        };

        dispatch({
            type: commonTypes.SALES_TRACKING_STATUS,
            payload: {
                status: 'loading'
            }
        });

        dispatch(
            sendRequest(REQUESTS.LOG_SALES_EVENT, {
                payload: {
                    body
                },
                onSuccess: () => updateStatus('success'),
                onError: () => updateStatus('error')
            })
        );
    };
